import { Routes, Route, Navigate } from 'react-router-dom'
import { NovaArte } from './Tabs/NovaArte'
import { BibliotecaDeArtes } from './Tabs/BibliotecaDeArtes'
import { ImageSelectionStep, FinalSelectionStep } from './Tabs/NovaArte/Steps'
import { PatternLayout } from './PatternLayout'

export function Pattern() {
  return (
    <Routes>
      <Route element={<PatternLayout />}>
        <Route path="/" element={<NovaArte />} />
        <Route path="/biblioteca" element={<BibliotecaDeArtes />} />
        <Route path="/generate-images/:taskId" element={<ImageSelectionStep />} />
        <Route path="/final-selection" element={<FinalSelectionStep />} />
        <Route path="*" element={<Navigate to="/pattern" replace />} />
      </Route>
    </Routes>
  )
}

// Arquivo atualizado para usar navegação baseada em rotas
// 1. A página principal de Pattern agora usa Routes/Route para renderizar os componentes
// 2. Cada step (GenerateImageStep, ImageSelectionStep, FinalSelectionStep) tem sua própria rota
// 3. A navegação entre steps é feita usando navigate() em vez de props onNext/onPrevious
// 4. As tabs também usam navegação baseada em rotas
// 5. O Header é compartilhado entre todas as páginas usando um layout com Outlet
// 1. A página principal de Pattern agora usa Routes/Route para renderizar os componentes
// 2. Cada step (GenerateImageStep, ImageSelectionStep, FinalSelectionStep) tem sua própria rota
// 3. A navegação entre steps é feita usando navigate() em vez de props onNext/onPrevious
// 4. As tabs também usam navegação baseada em rotas
